import { ApiClient } from '../lib/api';
import { z } from 'zod';

// Company schema
const CompanySchema = z.object({
  coid: z.number(),
  coname: z.string().nullable(),
  coexpdayscom: z.number().nullable(),
  coexpdaysres: z.number().nullable(),
  // Add other company fields as needed
});

export type Company = z.infer<typeof CompanySchema>;

export class CompanyService {
  private api: ApiClient;

  constructor(apiUrl: string, apiStage: string) {
    this.api = new ApiClient(`${apiUrl}/${apiStage}/company-service-${apiStage}`, apiStage);
  }

  // Get company by ID
  async getCompany(companyId: number): Promise<Company> {
    return await this.api.request(
      { method: 'GET', url: `/companies/${companyId}` },
      CompanySchema
    );
  }
} 